import {
  asString,
  parseEligibleRegionsField,
  parseKnownValue,
  parseObject,
  parseRequiredArrayField,
} from '~/utils/societePayloadBuilder/parseHelpers';

import { LUXPLUS_PROMO_CARD_TYPES, PROMO_CODE_PROMOTION } from '../constants';
import { parseOptionalExpiresAt } from '../payloadFields';
import { createPromoDraftLabel } from '../promos';

import { createDefaultPromoCard } from './defaults';
import type { LuxPlusPromoCard, LuxPlusPromoCardCarouselState } from './types';

function parsePromo(value: unknown, index: number): LuxPlusPromoCard {
  const source = parseObject(value, `Promo card ${index + 1}`);
  const defaults = createDefaultPromoCard(createPromoDraftLabel(index));

  return {
    ...defaults,
    type: parseKnownValue(source.type ?? PROMO_CODE_PROMOTION, LUXPLUS_PROMO_CARD_TYPES, `${defaults.draftLabel} Type`),
    label: asString(source.label),
    title: asString(source.title),
    subtitle: asString(source.subtitle),
    expiresAt: parseOptionalExpiresAt(source.expiresAt),
    eligibleRegions: parseEligibleRegionsField(source, `${defaults.draftLabel} Eligible Regions`),
    promoCode: asString(source.promoCode),
    termsAndConditions: asString(source.termsAndConditions),
    primaryActionText: asString(source.primaryActionText),
    primaryActionHref: asString(source.primaryActionHref),
    ctaText: asString(source.ctaText),
    ctaLink: asString(source.ctaLink),
  };
}

export function parsePromoCardCarouselPayload(value: unknown): LuxPlusPromoCardCarouselState {
  const source = parseObject(value, 'Payload');
  const promos = parseRequiredArrayField(source, 'promos').map((promo, index) => parsePromo(promo, index));

  return {
    mode: 'promoCardCarousel',
    promos,
  };
}
